/* AGDEL — Composer mon coffret : sélection de N parfums, ajout au panier avec les choix en propriétés */
(() => {
  'use strict';
  const root = document.querySelector('[data-coffret]');
  if (!root) return;
  const max = parseInt(root.dataset.max, 10);
  const picks = [...root.querySelectorAll('.agdel-pick')];
  const list = root.querySelector('[data-list]');
  const count = root.querySelector('[data-count]');
  const submit = root.querySelector('[data-submit]');
  const status = root.querySelector('[data-status]');
  if (!submit) return;
  const chosen = [];

  const render = () => {
    list.innerHTML = chosen.map((t) => `<li>${t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))}</li>`).join('');
    count.textContent = chosen.length;
    submit.disabled = chosen.length !== max;
    picks.forEach((b) => b.setAttribute('aria-pressed', String(chosen.includes(b.dataset.title))));
  };

  picks.forEach((b) => b.addEventListener('click', () => {
    const t = b.dataset.title, i = chosen.indexOf(t);
    if (i > -1) chosen.splice(i, 1);
    else if (chosen.length < max) chosen.push(t);
    else status.textContent = `Votre coffret est complet (${max} parfums). Retirez-en un pour en changer.`;
    if (chosen.length < max && i > -1) status.textContent = '';
    render();
  }));

  submit.addEventListener('click', async () => {
    submit.disabled = true; status.textContent = '';
    const properties = {};
    chosen.forEach((t, i) => { properties[`Parfum ${i + 1}`] = t; });
    try {
      const res = await fetch(root.dataset.addUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(root.dataset.variant), quantity: 1, properties }] }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Ajout impossible');
      window.location.href = root.dataset.cartUrl;
    } catch (e) { status.textContent = e.message; submit.disabled = false; }
  });
})();
